import {Resource} from 'simpli-web-sdk'

export class TipoResponsavelUsuario extends Resource {
  idTipoResponsavelUsuarioPk: number = 0
  nome: string | null = null

  get $id() {
    return this.idTipoResponsavelUsuarioPk
  }
  set $id(val) {
    this.idTipoResponsavelUsuarioPk = val
  }

  get $tag() {
    return String(this.nome)
  }
}
